import { find, isEqual } from 'lodash-es';
import { useMemo } from 'react';
import { EditData, TransferredData } from '../types';

const compareFieldsOnly = (
  data1: TransferredData[],
  data2: TransferredData[]
): boolean => {
  for (const category1 of data1) {
    const category2 = find(data2, { key: category1.key });
    if (!category2) {
      return true;
    }

    if (category1.entries.length !== category2.entries.length) {
      return true;
    }

    for (const entry1 of category1.entries) {
      const entry2 = find(category2.entries, { index: entry1.index });
      if (!entry2) {
        return true;
      }

      if (!isEqual(entry1.fields, entry2.fields)) {
        return true;
      }
    }
  }

  return false;
};

export function useHasChangesFields(
  transferredData: TransferredData[],
  editValue: EditData | undefined
): boolean {
  return useMemo(() => {
    if (!editValue || !editValue.value) {
      return false;
    }
    return compareFieldsOnly(transferredData, editValue.value);
  }, [transferredData, editValue]);
}
